import TagEditor from './TagEditor';
import { useTranslation } from 'react-i18next';
import { AppContext } from '../../services/AppContext';
import { ModalContext } from '../../modal/ModalContext';
import MultiButtons from '../../components/global/MultiButtons';
import { React, Fragment, useState, useContext, useEffect } from 'react';
import { DeleteConfirmationModal } from '../../modal/global/DeleteConfirmationModal';

const Tags = () => {
    const { t } = useTranslation();
    const { showModal } = useContext(ModalContext);
    const { apiClient, user, notify } = useContext(AppContext);
    const [tagData, setTagData] = useState([]);

    const handleAddTag = async () => {
        const created = await showModal(<TagEditor />);

        if (created) fetchData();
    };

    const handleEditTag = async (tag) => {
        const updated = await showModal(<TagEditor tag={tag} />);

        if (updated) fetchData();
    };

    const handleDelete = async (tag) => {
        const shouldDelete = await showModal(
            <DeleteConfirmationModal subject={tag.name} />
        );

        if (shouldDelete) {
            await apiClient.deleteTag(tag.id);
            fetchData();
            notify(t('pages.tags.notifications.deleted'), 'success');
        }
    };

    const fetchData = async () => {
        const data = await apiClient.getTags();

        if (!data.hasErrors) {
            setTagData(data);
        }
    };

    useEffect(() => {
        if (user.role === 'Admin') fetchData();
    }, []);

    return (
        user.role === 'Admin' && (
            <div>
                <div className="filter-container mg-b-1">
                    <button onClick={handleAddTag}>
                        {t('pages.tags.actions.add')}
                    </button>
                </div>

                <div className="grid-container-2">
                    <div className="grid-header">
                        <div className="container">
                            {t('pages.tags.headers.name')}
                        </div>
                    </div>
                    <div className="grid-header">
                        <div className="container">
                        </div>
                    </div>
                    {tagData?.map((tag, index) => (
                        <Fragment key={index}>
                            <div className="grid-item">
                                <div className="container">{tag.name}</div>
                            </div>

                            <MultiButtons>
                                <button
                                    className="background-warning width-100p"
                                    onClick={() => handleEditTag(tag)}
                                >
                                    {t('pages.tags.actions.edit')}
                                </button>
                                <button
                                    className="background-danger width-100p"
                                    onClick={() => handleDelete(tag)}
                                >
                                    {t('pages.tags.actions.delete')}
                                </button>
                            </MultiButtons>
                        </Fragment>
                    ))}
                </div>
            </div>
        )
    );
};

export default Tags;